import { AnimationPlayer, Box } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { StatusGemShowcaseProps } from './StatusGemShowcase.types';
import StatusNextGemLabel from '../StatusNextGemLabel/StatusNextGemLabel';
import animations from '../../assets/animations/showcase';
import StatusGemGlow from '../StatusGemGlow/StatusGemGlow';

function StatusGemShowcase({
  playerStatus,
  progressRingSize,
  currentPoints,
  totalPoints,
}: StatusGemShowcaseProps) {
  return (
    <Box
      position="absolute"
      top="space-0"
      bottom="space-0"
      right="space-0"
      left="space-0"
      justifyContent="center"
      alignItems="center"
    >
      <Box position="relative" justifyContent="center" alignItems="center">
        <AnimationPlayer
          source={animations[`${playerStatus}Showcase`]}
          loop
          sizeX={progressRingSize * 0.6}
          sizeY={progressRingSize * 0.6}
        />
        <StatusGemGlow status={playerStatus} />
        <StatusNextGemLabel
          currentPoints={currentPoints}
          totalPoints={totalPoints}
          playerStatus={playerStatus}
        />
      </Box>
    </Box>
  );
}

export default memo(StatusGemShowcase);
